import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { assetInventoryDefaultFilter } from '../../../../../views/Policies/AssetInventoryDashboard/utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/asset-inventory/')({
  validateSearch: zodValidator(withDefaults(schema.ASSET_INVENTORY, defaultFilter, assetInventoryDefaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
});
